import React from "react";
import { useForm } from "react-hook-form";
import newsletterService from "../../api/newsletter";

const TicketDetailsModal = ({ onClose, league_acronym, guestHash, access_id }) => {
    const storedData = JSON.parse(localStorage.getItem("ticketFormData")) || {};
    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            first_name: storedData.first_name || "",
            last_name: storedData.last_name || "",
            email: storedData.email || ""
        },
    });

  const onSubmit = async (data) => {
   const payload = {
        ...data,
        receive_news: false,
        league_acronym: league_acronym || "",
        access_id
    };
    try {
      await newsletterService.subscribeNewsletter(payload);
      if (guestHash) {
            localStorage.setItem("ticketFormData", JSON.stringify(data));
            const storedHashes = JSON.parse(localStorage.getItem("guestHashes")) || [];
            if (!storedHashes.includes(guestHash)) {
                storedHashes.push(guestHash);
                localStorage.setItem("guestHashes", JSON.stringify(storedHashes));
            }

        };
      onClose();
    } catch (err) {
      console.error(err);
      alert("Error submitting data. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-wrapper">
          <div className="modal-content">
        <h2 className="modal-title">TICKET ERHALTEN</h2>
        <p className="modal-description">Bitte Daten einmalig eintragen und dein SCB-Ticket und unseren Welcome-Newsletter erhalten. Viel Spass am Match!</p>

        <form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="first_name" className="input-label">VORNAME</label>
          <input
            id="first_name"
            name="first_name"
            placeholder="Vorname"
            ref={register({ required: "Daten fehlen" })}
            className={errors.first_name ? "input-error" : ""}
          />
          {errors.first_name && (
            <p className="error-message">{errors.first_name.message}</p>
          )}

          <label htmlFor="last_name" className="input-label">NACHNAME</label>
          <input
            id="last_name"
            name="last_name"
            placeholder="Nachname"
            ref={register({ required: "Daten fehlen" })}
            className={errors.last_name ? "input-error" : ""}
          />
          {errors.last_name && (
            <p className="error-message">{errors.last_name.message}</p>
          )}

          <label htmlFor="email" className="input-label">E-MAIL ADRESSE</label>
          <input
            id="email"
            name="email"
            type="text"
            placeholder="E-Mail Adresse"
            ref={register({
              required: "Daten fehlen",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Ungültige E-Mail-Adresse",
              },
            })}
            className={errors.email ? "input-error" : ""}
          />
          {errors.email && (
            <p className="error-message">{errors.email.message}</p>
          )}

          {/* <div className="checkbox-container">
            <input
              id="receive_news"
              type="checkbox"
              name="receive_news"
              ref={register}
            />
            <label htmlFor="receive_news">Ich möchte News des SCB per E-Mail erhalten.</label>
          </div> */}

          <button className="red-button" type="submit">
            TICKETANZEIGE
          </button>
          <div className="skip-button">
            <button onClick={onClose}>überspringen</button>
          </div>
        </form>
      </div>
      </div>
    </div>
  );
};

export default TicketDetailsModal;
